import React from 'react';
import { Reveal } from './Reveal';
const stats = [{
  value: '+500',
  label: 'Supports Cliniques'
}, {
  value: '1+5',
  label: 'Volume et Outils'
}, {
  value: '4,9/5',
  label: 'Évaluation ⭐'
}, {
  value: '🌍',
  label: 'France & International'
}];
export function StatsBar() {
  return <section className="w-full border-y border-ink-border bg-ink-soft px-4 py-10" data-id="element-226">
      <Reveal className="mx-auto grid max-w-5xl grid-cols-2 gap-6 text-center md:grid-cols-4" data-id="element-227">
        {stats.map(s => <div key={s.label} className="flex flex-col items-center" data-id="element-228">
            <span className="font-display text-3xl text-gold sm:text-4xl" data-id="element-229">
              {s.value}
            </span>
            <span className="mt-1 text-xs font-semibold uppercase tracking-wide text-white/55 sm:text-sm" data-id="element-230">
              {s.label}
            </span>
          </div>)}
      </Reveal>
    </section>;
}